if (jrConfigGlobal.isMobile) {
  const observer = new IntersectionObserver(function (entries) {
    const stickyAdvert = document.querySelector('.js-jpp-adver-info');

    if (stickyAdvert && entries.length > 0) {
      stickyAdvert.classList.toggle('jpp-advert__info--sticky', !entries[0].isIntersecting);
    }
  });

  observer.observe(document.querySelector('.js-jpp-advert-sentinel'));
}
